<div
  class="bg-component-inner border border-secondary-border rounded-xl shadow-md flex flex-col transition-all duration-300 w-full min-w-[300px]"
>
  <div
    class="px-4 py-3 bg-alt-background border-b border-secondary-border flex items-center justify-between rounded-t-xl"
  >
    <div class="flex items-center gap-2">
      <i class="fas fa-table text-primary text-lg"></i>
      <span class="font-semibold text-sm text-primary-text">
        {{ config.texts.dataResultsLabel }}
        <span class="text-primary">{{ entityName }}</span>
      </span>
    </div>

    @if (hasMultipleItems()) {
      <div
        class="flex items-center bg-component-inner border border-secondary-border rounded-md overflow-hidden"
      >
        <button
          nz-button
          nzType="text"
          nzSize="small"
          class="border-none focus:outline-none flex items-center justify-center w-8 h-8 rounded-none transition-colors"
          [ngClass]="
            showGrid()
              ? 'text-secondary-text hover:text-primary'
              : 'bg-alt-bold-background text-primary shadow-sm'
          "
          (click)="showGrid.set(false)"
          nz-tooltip
          [nzTooltipTitle]="config.texts.dataCardViewLabel"
        >
          <i class="fas fa-address-card text-sm"></i>
        </button>
        <div class="w-px h-4 bg-secondary-border"></div>
        <button
          nz-button
          nzType="text"
          nzSize="small"
          class="border-none focus:outline-none flex items-center justify-center w-8 h-8 rounded-none transition-colors"
          [ngClass]="
            showGrid()
              ? 'bg-alt-bold-background text-primary shadow-sm'
              : 'text-secondary-text hover:text-primary'
          "
          (click)="showGrid.set(true)"
          nz-tooltip
          [nzTooltipTitle]="config.texts.tableViewLabel"
        >
          <i class="fas fa-table text-sm"></i>
        </button>
      </div>
    }
  </div>

  @if (isGridLoading) {
    <div class="p-4 bg-alt-bold-background animate-pulse flex flex-col gap-3">
      <div class="h-6 bg-component-inner rounded w-1/3"></div>
      <div class="h-24 bg-component-inner rounded w-full mt-2"></div>
      <div class="flex items-center justify-between mt-2">
        <div class="h-6 bg-component-inner rounded w-1/4"></div>
        <div class="h-6 bg-component-inner rounded w-1/4"></div>
      </div>
    </div>
  } @else {
    <div
      class="p-4 bg-alt-bold-background border-b border-secondary-border custom-scrollbar overflow-x-auto max-h-[400px]"
    >
      @if (showGrid() && gridConfig) {
        @defer {
          <rapider-list-grid
            [config]="gridConfig"
            [data]="data"
          ></rapider-list-grid>
        } @loading {
          <div
            class="p-4 bg-alt-bold-background flex justify-center items-center h-24"
          >
            <i class="fas fa-circle-notch fa-spin text-primary text-2xl"></i>
          </div>
        }
      } @else {
        @for (index of displayIndices(); track index) {
          <div
            class="p-3 bg-component-inner rounded-lg shadow-sm border border-secondary-border mb-3 last:mb-0"
          >
            <div class="flex items-center gap-2 mb-2">
              <span
                class="bg-primary text-primary-button-text rounded px-1.5 py-0.5 text-[10px] font-bold shadow-sm"
                >#{{ index + 1 }}</span
              >

              @if (getExtractedMetaTitlePure(extractedMeta(), index)) {
                <h4 class="text-sm font-semibold text-primary-text m-0">
                  {{ getExtractedMetaTitlePure(extractedMeta(), index) }}
                </h4>
              }
            </div>
            <hr class="my-2 border-secondary-border" />

            <rapider-json-viewer
              [data]="getCleansedEntityDataAtPure(cleansedData(), index)"
              [maxLineToDisplay]="20"
              class="w-full h-auto"
            ></rapider-json-viewer>
          </div>
        }

        @if (hasMultipleItems() && !showAll() && !showGrid()) {
          <button
            nz-button
            nzType="dashed"
            nzBlock
            class="mt-1 border-secondary-border text-secondary-text hover:text-primary hover:border-primary font-medium"
            (click)="toggleShowAll()"
          >
            <i class="fas fa-chevron-down mr-2"></i>
            {{ config.texts.showAllButton }} ({{ data.length }})
          </button>
        }
      }
    </div>

    <div
      class="px-4 py-3 bg-alt-background flex items-center justify-end rounded-b-xl"
    >
      <button
        nz-button
        nzType="default"
        class="border-secondary-border text-secondary-text hover:text-primary hover:border-primary focus:outline-none flex items-center gap-2 rounded-md font-medium px-4 py-2 h-auto"
        (click)="showInCanvas.emit()"
      >
        <i class="fa-regular fa-browser"></i>
        <span>&nbsp;{{ config.texts.showInCanvasButton }}</span>
      </button>
    </div>
  }
</div>
